<div>
  <div class="toolbar">
    <button nz-button nzType="text" (click)="findText()">
      <span nz-icon nzType="search"></span>
      Find
    </button>
    <button nz-button nzType="text" (click)="copyCode()">
      <span nz-icon nzType="copy"></span>
      Insert Code
    </button>
    <button nz-button nzType="text" (click)="copyFromCursorToBottom()">
      <span nz-icon nzType="down"></span>
      Insert to Bottom
    </button>
    <button nz-button nzType="text" (click)="copyFromCursorToTop()">
      <span nz-icon nzType="up"></span>
      Insert to Top
    </button>
  </div>
  <div #editorContainer class="editor-container" [class.expanded]="expanded"></div>
</div>
